import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { NotificationService } from './notification.service';
import { EtagEntityType, EtagRecord, EtagService } from './etag.service';
import { IFormContractResponse } from '../models/request-and-responses/rest-api/interfaces/formContractResponse';
import { IPataviumPagedResponse } from '../helpers/response.class';
import { catchError, tap } from 'rxjs/operators';
import { SessionStorageService } from './session-storage.service';

export class FieldErrorMessage {
    public fields: string;
    public message: string;
}

export class PataviumException {
    public error: string;
    public message: string;
    public name: string;
}

export class ValidationErrors {
    public message: string;
    public errors: FieldErrorMessage[];
    public name: string;
}

@Injectable()
export class PTVMHttpInterceptor implements HttpInterceptor {
    private readonly _etagService: EtagService;
    private statusCodePopup = [400, 409];
    private readonly NUMBER_OF_ERRORS_TO_SHOW: number = 5;
    constructor(
        private router: Router,
        private toastr: ToastrService,
        private notificationService: NotificationService,
        public etagService: EtagService
    ) {
        this._etagService = etagService;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = SessionStorageService.jwt;
        if (token.isPresent()) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token.get()}`
                }
            });
        } else {
            SessionStorageService.role.remove();
            SessionStorageService.username.remove();
        }

        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const requestUrl = request.url;
                    const methodRequest = request.method;
                    const etag = event.headers.get('etag');
                    if (methodRequest.toUpperCase() === 'GET' && etag) {
                        console.log('Etag found : ' + etag);
                        console.log('requestUrl found : ' + requestUrl);
                        if (/\/contracts\/\d+/.test(requestUrl)) {
                            console.log(event.body);
                            const response = event.body as IPataviumPagedResponse<IFormContractResponse>;
                            const recordContract = new EtagRecord();
                            recordContract.etag = etag;
                            recordContract.id = response.payload[0].contract.id;
                            recordContract.eType = EtagEntityType.Contract;
                            this._etagService.setEtagEntity(recordContract);
                        }
                    }
                }
            }),
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse && this.statusCodePopup.safeContains(err.status)) {
                    const httpErrorResponse: HttpErrorResponse = err; // only useful for ide
                    let errContent = null;
                    // if the error is an ArrayBuffer decode it
                    if (httpErrorResponse.error instanceof ArrayBuffer) {
                        try {
                            const decoder = new TextDecoder('utf-8');
                            const decodedObject = decoder.decode(err.error);
                            errContent = JSON.parse(decodedObject);
                        } catch (e) {
                            console.error('Caught exception trying decoding an error', e);
                        }
                    } else {
                        errContent = httpErrorResponse.error;
                    }
                    if (errContent instanceof Object) {
                        // first look for 'errors' then message
                        if ('errors' in errContent) {
                            const validationErrors: ValidationErrors = errContent as ValidationErrors;
                            validationErrors.errors.slice(-this.NUMBER_OF_ERRORS_TO_SHOW).forEach(error => {
                                this.toastr.warning(error.message, '', {
                                    closeButton: true,
                                    disableTimeOut: true
                                });
                            });
                            this.toastr.error('', validationErrors.message, {
                                closeButton: true,
                                disableTimeOut: true
                            });
                            this.notificationService.broadcast(
                                validationErrors.errors.map(e => e.message)
                            );
                        } else if ('message' in errContent) {
                            const pataviumException: PataviumException = errContent as PataviumException;
                            this.toastr.error(pataviumException.message, 'Attenzione', {
                                closeButton: true,
                                disableTimeOut: true
                            });
                        } else {
                            console.log(`Unrecognized error content`, errContent);
                        }
                    } else {
                        console.log(`Unhandled error type ${typeof errContent}`, errContent);
                    }
                }
                throw err;
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/services/http-interceptor.service.ts